var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutobrightness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7499 2.45007C11.4499 1.86007 12.5799 1.86007 13.2599 2.45007L14.8399 3.80007C15.1399 4.05007 15.7099 4.26007 16.1099 4.26007H17.8099C18.8699 4.26007 19.7399 5.13007 19.7399 6.19007V7.89007C19.7399 8.29007 19.9499 8.85007 20.1999 9.15007L21.5499 10.7301C22.1399 11.4301 22.1399 12.5601 21.5499 13.2401L20.1999 14.8201C19.9499 15.1201 19.7399 15.6801 19.7399 16.0801V17.7801C19.7399 18.8401 18.8699 19.7101 17.8099 19.7101H16.1099C15.7099 19.7101 15.1499 19.9201 14.8499 20.1701L13.2699 21.5201C12.5699 22.1101 11.4399 22.1101 10.7599 21.5201L9.17988 20.1701C8.87988 19.9201 8.30988 19.7101 7.91988 19.7101H6.16988C5.10988 19.7101 4.23988 18.8401 4.23988 17.7801V16.0701C4.23988 15.6801 4.03988 15.1101 3.78988 14.8201L2.43988 13.2301C1.85988 12.5401 1.85988 11.4201 2.43988 10.7301L3.78988 9.14007C4.03988 8.84007 4.23988 8.28007 4.23988 7.89007V6.20007C4.23988 5.14007 5.10988 4.27007 6.16988 4.27007H7.89988C8.29988 4.27007 8.85988 4.06007 9.15988 3.81007L10.7499 2.45007Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.9401L12 8.06006L15.5 15.9401",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 13.3101H10.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutobrightness);
export default ForwardRef;